
<div class="floatingButtonWrap">
  <div class="floatingButtonInner">
      <span class="floatingButton" id="floatingButton">
          <i class="fa fa-plus icon-default"></i>
      </span>
      <ul class="floatingMenu" id="floatingMenu">
          <li>
              <a href="">Invest Now</a>
          </li>
      </ul>
  </div>
</div>